import {
  Dialog,
  DialogCloseButton,
  DialogContent,
} from '@wwe-portal/ui/components/dialog';
import type { SubscriptionTier } from '@wwe-portal/entities/subscription.type';
import type { MissionRewardCardProps } from '@wwe-portal/ui/features/club-store/milestone/mission-reward-card';
import MissionRewardCard from '@wwe-portal/ui/features/club-store/milestone/mission-reward-card';
import type { OfferCardProps } from '@wwe-portal/ui/features/offer/type';

export interface OfferDialogProps {
  onClose?: () => void;
  open?: boolean;
  data: MissionRewardCardProps | undefined;
  handleBuy: (data: {
    tier: SubscriptionTier;
    offerData: OfferCardProps;
  }) => void;
  loading?: boolean;
  onReferSubscription?: () => void;
}
export function OfferDialog({
  open,
  onClose,
  data,
  handleBuy,
  loading = false,
  onReferSubscription,
}: Readonly<OfferDialogProps>) {
  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose?.();
      }}
      open={open}
    >
      <DialogContent
        className="from-back400 to-back400 w-[calc(100%-32px)] max-w-[300px] md:max-w-[420px]"
        data-id="clubstore-offer-details-dialog"
        variant="dialog"
      >
        {data && (
          <MissionRewardCard
            {...data}
            isBlocked={data.isBlocked ?? false}
            loading={loading}
            onClick={handleBuy}
            onReferSubscription={() => onReferSubscription?.()}
          />
        )}
        <DialogCloseButton onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
}

export default OfferDialog;
